export default __webpack_public_path__ + "static/media/about-first.7c24d3c6.jpg";